export default __webpack_public_path__ + "static/media/oglasnik.5a526f3e.png";